import { AppLayout } from "components/common/layout/AppLayout/styles";

export default AppLayout;
